(function () {
  'use strict';

  angular.module('wsLrs.services').factory("RequestCache", ['$q', '$timeout', 'Utils', function ($q, $timeout, Utils) {
    var requestCache = [],
      maxRequestCacheLength = 50;
    function get(key, orElse) {
      key = Utils.md5(key);
      var entry = _.find(requestCache, function (item) {
        return item[0] === key;
      });
      if (!entry) {
        entry = [key, orElse()];
        requestCache.push(entry);
        if (requestCache.length > maxRequestCacheLength) {
          requestCache.shift();
        }
      }

      // We defer the result in order to maintain a consistent
      // timing behavior with async fetches of requests
      var future = $q.defer();
      $timeout(function () {
        future.resolve(entry[1]);
      });
      return future.promise;
    }
    function clear(key) {
      if (key) {
        delete requestCache[key];
      } else {
        requestCache = [];
      }
    }
    return {
      get: get,
      clear: clear
    };
  }]);
})();
